import { Serializable } from '@/models/core/serializable';
import { GEnum } from '@/constants/enum.defination';

export class Activity implements Serializable<Activity> {
  activityID: number;
  activityName: string;
  activityItems: ActivityItem[];
  companyID: number;
  isSelected: boolean = false;

  get isSelect(): boolean {
    return this.isSelected;
  }

  deserialize(input: any) {
    this.activityID = input.ID;
    this.activityName = input.activityName;
    if (input.activityItems) {
      this.activityItems = input.activityItems.map((item: any) => new ActivityItem().deserialize(item));
    }
    this.companyID = input.companyID;
    return this;
  }
}

export class ActivityItem implements Serializable<ActivityItem> {
  activityItemID: number;
  activityItemName: string;
  activityItemCategoryID: number;
  activityItemCategoryName: string;

  deserialize(input: any) {
    this.activityItemID = input.ID;
    this.activityItemName = input.activityItemName;
    this.activityItemCategoryID = input.activityItemCategoryID;
    this.activityItemCategoryName = input.activityItemCategoryName;
    return this;
  }
}

export class ActivityItemCategory implements Serializable<ActivityItemCategory> {
  activityItemCategoryID: number;
  activityItemCategoryName: string;
  activityItems: ActivityItem[];
  selectedItems: number[] = [];

  deserialize(input: any) {
    this.activityItemCategoryID = input.ID;
    this.activityItemCategoryName = input.categoryName;
    this.activityItems = input.items.map((item: any) => new ActivityItem().deserialize(item));
    return this;
  }
}

export class CreateActivityParam {
  activityName: string;
  activityItems: number[];

  set acvitityItemName(val: string) {
    this.acvitityItemName = val;
  }
}

export class UpdateActivityParam {
  ID: number;
  activityName: string;
}